import styled from 'styled-components'
import {
  height,
  HeightProps,
  maxHeight,
  MaxHeightProps,
  maxWidth,
  MaxWidthProps,
  width,
  WidthProps,
} from 'styled-system'

import { DIV_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'

export type ContainerProps = WidthProps &
  HeightProps &
  MaxHeightProps &
  MaxWidthProps

const shouldForwardProp = (prop: string | number) => {
  return !DIV_SHOULD_FORWARD_PROP.includes(String(prop))
}

export const Container = styled.div.withConfig({
  shouldForwardProp,
})<ContainerProps>`
  display: flex;
  align-items: center;
  justify-content: center;

  ${width}
  ${height}
  ${maxWidth}
  ${maxHeight}
`
